import { render, staticRenderFns } from "./Trucks.vue?vue&type=template&id=39723722&scoped=true"
import script from "./Trucks.vue?vue&type=script&lang=js"
export * from "./Trucks.vue?vue&type=script&lang=js"
import style0 from "./Trucks.vue?vue&type=style&index=0&id=39723722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39723722",
  null
  
)

export default component.exports